import { Subscription } from 'rxjs';

export class AllQualityIssueAttachment {
	id?: number | undefined;
	hash = '';
	name = '';
	type = '';
	size = 0;
	path = '';
	creationDate = '';
	creationBy = '';
	localUrl?: string | undefined;
	localFile?: File | undefined;
	error? = false;
	sending? = false;
	progress?: number | undefined = undefined;
	uploadSub?: Subscription;
	chronicleId?: string;
	repository?: string;
}

export interface DocamonResponse {
	chronicleId: string;
	repository: string;
}
